<template>
  <div
    class="sticky-box"
    :class="bem('sticky-box', { position, sticky: shouldStuck })"
  >
    <slot />
  </div>
</template>

<script>
  import { bem } from "src/utils/bem.js";
  import BasicSection from "src/components/sections/BasicSection/BasicSection.vue";

  const isTextInput = (element) => {
    const type = element.type;
    const tagName = element.tagName.toLowerCase();
    if (tagName === 'textarea') return true;
    return tagName === 'input' && type === 'text';
  };

  export default {
    name: 'StickyBox',
    components: { BasicSection },
    props: {
      position: {
        type: String,
        default: 'bottom'
      }
    },
    data() {
      return {
        hasInteractiveElementInFocus: false,
      }
    },
    mounted() {
      if (isTextInput(document.activeElement)) {
        this.hasInteractiveElementInFocus = true;
      }
      document.addEventListener('focusin', this.onFocus);
      document.addEventListener('focusout', this.onBlur);
    },
    beforeDestroy() {
      document.removeEventListener('focusin', this.onFocus);
      document.removeEventListener('focusout', this.onBlur);
    },
    methods: {
      bem,
      onFocus(event) {
        if (isTextInput(event.target)) {
          this.hasInteractiveElementInFocus = true;
        }
      },
      onBlur(event) {
        this.hasInteractiveElementInFocus = false;
      },
    },
    computed: {
      shouldStuck() {
        return !this.hasInteractiveElementInFocus;
      }
    }
  }
</script>